export const LOADER_HEIGHT = 24;
export const LOADER_WIDTH = 24;
export const LOADER_COLOR = "#fff";
